import { EthAccountButton } from '@xylabs/sdk-react'
import { useContext } from 'react'

import { EthersContext } from '../../Contexts'
import { Property } from '../Property'

const LocalAddressProperty: React.FC = () => {
  const { localAddress } = useContext(EthersContext)

  return (
    <Property title="Local Address" value={localAddress?.toString()}>
      <EthAccountButton variant="outlined" address={localAddress} addressLength="auto" />
    </Property>
  )
}

export default LocalAddressProperty
